import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [unreadCount, setUnreadCount] = useState(0);
    const [notifications, setNotifications] = useState([]);

    return (
        <NotificationContext.Provider value={{ unreadCount, setUnreadCount, notifications, setNotifications }}>
            {children}
        </NotificationContext.Provider>
    );
};

export default NotificationContext;
